/**
 * @generated SignedSource<<e7cdccb4c134747445e3c8d14c68cf03>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type BountyStatus = "ACTIVE" | "ACTIVE_BUT_BONUS_EXISTS" | "CLAIMED" | "FINISHED" | "PAUSED" | "RE_CLAIMABLE" | "%future added value";
export type ClaimBountyInput = {
  bountyId?: number | null;
  code?: string | null;
};
export type BountiesContextClaimBountyMutation$variables = {
  input: ClaimBountyInput;
};
export type BountiesContextClaimBountyMutation$data = {
  readonly claimBounty: {
    readonly bounty: {
      readonly bountyId: number;
      readonly amount: number;
      readonly currency: string;
      readonly title: string;
      readonly subtitle: string;
      readonly extendedInfo: string;
      readonly bgImageUrl: string | null;
      readonly rating: number;
      readonly status: BountyStatus;
      readonly expires: string | null;
      readonly claimCount: number;
      readonly claimLimit: number;
    };
  } | null;
};
export type BountiesContextClaimBountyMutation = {
  variables: BountiesContextClaimBountyMutation$variables;
  response: BountiesContextClaimBountyMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ClaimBountyPayload",
    "kind": "LinkedField",
    "name": "claimBounty",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Bounty",
        "kind": "LinkedField",
        "name": "bounty",
        "plural": false,
        "selections": [
          {
            "alias": "bountyId",
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "amount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "currency",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "title",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "subtitle",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "extendedInfo",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "bgImageUrl",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "rating",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "expires",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "claimCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "claimLimit",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "BountiesContextClaimBountyMutation",
    "selections": (v1/*: any*/),
    "type": "RootMutationType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "BountiesContextClaimBountyMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "e6bfdc5810cdbdbf08077a2a8796c7d8",
    "id": null,
    "metadata": {},
    "name": "BountiesContextClaimBountyMutation",
    "operationKind": "mutation",
    "text": "mutation BountiesContextClaimBountyMutation(\n  $input: ClaimBountyInput!\n) {\n  claimBounty(input: $input) {\n    bounty {\n      bountyId: id\n      amount\n      currency\n      title\n      subtitle\n      extendedInfo\n      bgImageUrl\n      rating\n      status\n      expires\n      claimCount\n      claimLimit\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "7e0855e95066840e11e26fc45cd59269";

export default node;
